// extracted by mini-css-extract-plugin
module.exports = {"trashIconError":"Modals_trashIconError__WM11W","reloadButtonContainer":"Modals_reloadButtonContainer__1GnMz","reservationError":"Modals_reservationError__3OTDD"};